import React, { useState } from 'react';
import { verificationCodeRequest } from '../network/post_authsand';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { signUp } from '../network/signup';
import { MdArrowBackIos } from "react-icons/md";

function AccountSetupForm() {
  const [gender, setGender] = useState('M'); // 'M' for 남성, 'W' for 여성
    const [id, setId] = useState(''); 
        const [pw, setPw] = useState(''); 
            const [pwchk, setPwchk] = useState(''); 
  const [isAgreed, setIsAgreed] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
    const [authNumber, setAuthNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false); // ⭐️ 로딩 상태 추가
    const [isSend, setIsSend] = useState(false); // 
    //const [extraHeader, setExtraHeader] = useState('username'); // 
    const [authMessage, setAuthMessage] = useState(''); // ⭐️ 사용자 피드백 메시지 상태
    const [searchParams] = useSearchParams();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
        const [refer, setRefer] = useState('');

    

          const navigate = useNavigate();

  // 컴포넌트 내부에 상태 관리 로직 (onChange, validation 등)을 추가할 수 있습니다.

  const usertype = searchParams.get('id'); 
  const accessToken = searchParams.get('socialAccountToken'); 

   const goBack = () => {
    // navigate(-1)을 호출하여 이전 경로로 이동
    navigate(-1);
  };


     const _signUp = async () => {
    // navigate(-1)을 호출하여 이전 경로로 이동

    if(!id){
          setModalMessage("아이디를 입력해주세요");
          setShowErrorModal(true);
          return

    }else if(!pw){
          setModalMessage("비밀번호를 입력해주세요");
          setShowErrorModal(true);
          return

    }else if(pw.length < 7){
          setModalMessage("8자 이상의 비밀번호를 입력해주세요");
          setShowErrorModal(true);
          return

    }
    else if(!phoneNumber){
          setModalMessage("휴대폰 번호를 입력해주세요");
          setShowErrorModal(true);
          return

    }else if(!authNumber){
          setModalMessage("인증번호를 입력해주세요");
          setShowErrorModal(true);
          return

    }else if(pw != pwchk){
          setModalMessage("비밀번호를 확인해주세요");
          setShowErrorModal(true);
          return

    }
       if(!isAgreed){
          setModalMessage("이용약관 및 개인정보처리방침에 동의해주세요");
          setShowErrorModal(true);
          return
    }
                  const result = await signUp(usertype,id,pw,authNumber,phoneNumber,gender,refer,accessToken)
                  console.log(result)
                if(result == 's'){
                  navigate(`/`);
                }
  };




  const handleAuthRequest = async () => {
        setAuthMessage(''); // 이전 메시지 초기화
        
        if (!phoneNumber || phoneNumber < 10) {
            setModalMessage("휴대폰번호를 입력해 주세요");
            

            setShowErrorModal(true);
            return
        }

        const result = await verificationCodeRequest(
            phoneNumber,
            'signup', // purpose (목적) 설정
            setIsLoading // 로딩 상태 제어 함수 전달
        );

        console.log(result)
        console.log(result.success)
        
        if (result.success) {
            setAuthMessage(result.message || '인증번호 발송 성공!');
            setIsSend(true)
            // 성공 시, 인증번호 입력 필드를 보여주는 로직 추가
        } else {
            // 실패 메시지 표시

            const failMessage = result.message || '인증 요청에 실패했습니다.';
            setModalMessage(failMessage);
            
            // 2. 팝업 표시 상태를 true로 설정
            setShowErrorModal(true);
            
            setIsLoading(false)
            
        }
    };


  return (
    <div style={styles.mobileContainer}>

      <MdArrowBackIos size="24" onClick={goBack} style={{marginTop:'1vw', marginRight:'25vw'}} />

      {showErrorModal && (
                <ErrorDisplayModal
                    message={modalMessage}
                    onClose={() => setShowErrorModal(false)}
                />
            )}
      
      {/* 1. 헤더 영역 */}
      <div style={styles.header}>
        <h1 style={styles.title}>계정정보</h1>
        <p style={styles.subtitle}>로그인 시 사용하실 계정 정보 설정해 주세요.</p>
      </div>

      {/* 2. 기본 정보 입력 섹션 */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>기본정보입력</h3>
        
        <input style={styles.inputField} type="text" placeholder="아이디를 입력해주세요" value={id}
                        onChange={(e) => setId(e.target.value)}/>
        <input style={styles.inputField} type="password" placeholder="8~20자리 비밀번호를 입력해 주세요" value={pw}
                        onChange={(e) => setPw(e.target.value)}/>
        <input style={styles.inputField} type="password" placeholder="비밀번호를 확인해 주세요" value={pwchk}
                        onChange={(e) => setPwchk(e.target.value)}/>
      </div>

      {/* 3. 필수 정보 입력 섹션 */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>필수정보입력</h3>
        
        {/* 휴대폰 번호 및 인증번호 버튼 그룹 */}
        <div style={styles.phoneGroup}>
          <input style={styles.phoneInput} type="tel" placeholder="휴대폰 번호를 입력해주세요" value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        disabled={isLoading} />
          <button 
                        onClick={handleAuthRequest} 
                        style={styles.authButton}
                        // 유효성 검사 추가
                    >
                         인증번호 받기
                    </button>
        </div>

        {isSend ?
        <div style={styles.phoneGroup}>
          <input style={styles.phoneInput} type="tel" placeholder="인증번호를 입력해주세요" value={authNumber}
                        onChange={(e) => setAuthNumber(e.target.value)}
                        />
        </div>:
        <div></div>
        }
        
        {/* 성별 선택 버튼 그룹 */}
        <div style={styles.genderGroup}>
          <button 
            onClick={() => setGender('M')}
            style={gender == 'M' ? styles.genderButtonActive : styles.genderButtonInactive}
          >
            남성
          </button>
          <button 
            onClick={() => setGender('W')}
            style={gender == 'W' ? styles.genderButtonActive : styles.genderButtonInactive}
          >
            여성
          </button>
        </div>

        <input style={styles.inputField} type="text" placeholder="추천인 코드를 입력해주세요(옵션)" value={refer}
                        onChange={(e) => setRefer(e.target.value)}/>
      </div>

      {/* 4. 약관 동의 섹션 */}
      <div style={styles.agreementSection}>
        <input 
          type="checkbox" 
          id="agreement" 
          checked={isAgreed}
          onChange={(e) => setIsAgreed(e.target.checked)}
          style={styles.checkbox}
        />
<label htmlFor="agreement" style={styles.agreementText}>
    모디 
    
    {/* ⭐️ 1. 이용약관 링크 */}
    <a 
        href="https://bit.ly/termsofuse_modii" 
        target="_blank" // 새 탭에서 열기
        rel="noopener noreferrer" // 보안을 위해 추가
        style={styles.linkStyle} // 링크 스타일 적용 (선택 사항)
    >
        이용약관
    </a> 
    
    및 
    
    {/* ⭐️ 2. 개인정보처리방침 링크 */}
    <a 
        href="https://bit.ly/privacy_modii" 
        target="_blank"
        rel="noopener noreferrer"
        style={styles.linkStyle} // 링크 스타일 적용 (선택 사항)
    >
        개인정보처리방침
    </a>
    
    에 대한 내용을 확인하고 동의합니다.
</label>
      </div>

      {/* 5. 다음 버튼 */}
      <button 
        style={styles.nextButton}
        //disabled={!isAgreed} // 약관에 동의해야 버튼 활성화
        onClick={_signUp}
      >
        다음
      </button>

    </div>
  );
}

function ErrorDisplayModal({ message, onClose }) {
    return (
        <div style={errorModalStyles.backdrop}>
            <div style={errorModalStyles.content}>
                <p style={errorModalStyles.message}>{message}</p>
                <button onClick={onClose} style={errorModalStyles.confirmButton}>
                    확인
                </button>
            </div>
        </div>
    );
}

// ----------------------------------------------------
// 스타일 정의 (모바일 최적화)
// ----------------------------------------------------


const errorModalStyles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '30px',
        width: '80%',
        maxWidth: '300px',
        textAlign: 'center',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '15px',
        color: '#ff4d4f', // 에러 강조색
    },
    message: {
        fontSize: '15px',
        marginBottom: '20px',
        color: '#333',
    },
    confirmButton: {
        width: '100%',
        padding: '10px',
        backgroundColor: '#ff4d4f',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontSize: '16px',
        cursor: 'pointer',
    }
};

const styles = {
  authFeedback: {
        fontSize: '14px',
        color: 'red',
        marginTop: '-10px',
        marginBottom: '10px',
    },

  mobileContainer: {
    maxWidth: '420px',
    margin: '0 auto',
    padding: '0 30px', // 좌우 패딩
    backgroundColor: 'white',
    minHeight: '100vh',
  },
  header: {
    marginBottom: '30px',
    textAlign: 'left',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    margin: 0,
  },
  
  // 섹션 스타일
  section: {
    marginBottom: '20px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '15px',
  },
  
  // 입력 필드 스타일
  inputField: {
    width: '100%',
    padding: '12px 15px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: '10px',
    fontSize: '16px',
    boxSizing: 'border-box', // padding이 width에 포함되도록 설정
  },
  
  // 휴대폰 인증 그룹
  phoneGroup: {
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
  },
  phoneInput: {
    
    flexGrow: 1,
    marginBottom: 0, // phoneGroup 내에서 마진 제거
  },
  authButton: {
    flexShrink: 0, // 버튼 크기 고정
    padding: '12px 15px',
    backgroundColor: '#ff4d4f', // 이미지의 회색 버튼
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },

  // 성별 버튼 그룹
  genderGroup: {
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
  },
  genderButtonActive: {
    flex: 1,
    padding: '15px',
    backgroundColor: '#ff4d4f', // 활성: 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  genderButtonInactive: {
    flex: 1,
    padding: '15px',
    backgroundColor: '#9e9e9eff', // 비활성: 회색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  
  // 약관 동의 섹션
  agreementSection: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '30px',
  },
  checkbox: {
    flexShrink: 0,
    width: '20px',
    height: '20px',
    marginRight: '10px',
    marginTop: '2px',
    cursor: 'pointer',
  },
  agreementText: {
    fontSize: '14px',
    color: '#333',
    textAlign: 'left',
  },
  redText: {
    color: '#ff4d4f', // 빨간색 강조
    fontWeight: 'bold',
  },
  
  // 다음 버튼
  nextButton: {
    width: '100%',
    padding: '15px 0',
    backgroundColor: '#ff4d4f', // 비활성 시 회색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    // ⭐️ 활성화 시 색상 변화는 CSS나 조건부 스타일로 처리해야 합니다.
    // disabled={!isAgreed} 속성이 비활성 시 색상을 유지하도록 했습니다.
  },
};

export default AccountSetupForm;